import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { postZipFile } from '../../../redux/actions/batchProductCreator'
import { postCsvFile } from '../../../redux/actions/batchProductCreator'
import { Button, Header, Segment } from 'semantic-ui-react'
import { AppState } from '../../../redux/store'
import CSVDownloader from '../CSVDownloader'

const StepOneZipUploader = () => {
  const [zipFile, setZipFile] = useState<any | null>(null)
  const [submitted, setSubmitted] = useState(false)
  const dispatch = useDispatch()

  const zipFileData = useSelector((state: AppState) => state.batchProductCreator.zipFileResult)

  const [csvFile, setCsvFile] = useState<any | null>(null)

  const submitCsvFile = function () {
    const formData = new FormData()
    formData.append('products', csvFile)
    dispatch(postCsvFile({ formData }))
  }
  useEffect(() => {
    return () => {
      setSubmitted(false)
    }
  }, [zipFileData])

  return (
    <div>
      <Header as="h2" attached="top">
        Upload ZIP File of Product Images (optional, but must come first)
      </Header>
      <Segment attached>
        Your ZIP file should not have any folders within it. It should simply have the the file
        images, e.g. "a.jpg" and "b.jpg", at the root level.
      </Segment>
      <form>
        <input
          type="file"
          name="zipFile"
          onChange={({ target }) => setZipFile(target && target.files && target.files[0])}
        />
      </form>

      <Button
        fluid
        primary
        disabled={!zipFile || submitted}
        onClick={() => {
          setSubmitted(true)
          dispatch(postZipFile({ zipFile }))
        }}
        style={{ marginTop: 25 }}
      >
        Submit ZIP file
      </Button>
      <Header as="h2" attached="top">
        Upload CSV File of Products
      </Header>
      <Segment attached>
        <p>
          <CSVDownloader />
        </p>
        <p style={{ color: 'red' }}>
          <strong>
            Important: The headings in the CSV Template have changed and the previous template will
            no longer work. Please download the new version before uploading your products.
          </strong>
        </p>
        <p>
          The "Photo" column should be the filename and extension. For example, if you have an image
          in your zip file named "a.jpg", you should type "a.jpg" in the "Photo" column for the
          appropriate row.{' '}
        </p>
        <p>
          The "Aliases" column should be separated by a semi-colon, without spaces, e.g. "alias
          1;alias 2;alias 3".
        </p>
      </Segment>
      <form>
        <input
          type="file"
          name="csvFile"
          onChange={({ target }) => {
            if (!target || !target.files) {
              return
            }
            const file = target.files[0]
            setCsvFile(file)
          }}
        />
      </form>
      <Button
        fluid
        primary
        style={{ marginTop: 25 }}
        disabled={!csvFile}
        onClick={() => submitCsvFile()}
      >
        Submit CSV file
      </Button>
    </div>
  )
}

export default StepOneZipUploader
